<template>
  <div class="block-n">
    <div class="block-n__row">
      <div class="block-n__head block-n__head--1">
        <div class="block-n__title block-n__title--1" data-aos="fade-right">Непереносимость</div>
        <div class="block-n__title block-n__title--2" data-aos="fade-right"><span>* intolerance to</span></div>
      </div>
      <div class="block-n__letter letter letter-line" data-aos="fade-up">
        Н.
      </div>
      <div class="block-n__head block-n__head--2">
        <div class="block-n__title block-n__title--3" data-aos="fade-left"><span>English speech</span></div>
        <div class="block-n__title" data-aos="fade-left">английской речи*</div>
      </div>
    </div>
    <div class="block-n__text text-white" data-aos="fade-up">После ряда успешных выступлений в Нью-Йорке Вертинскому поступило предложение сняться <br>в кино в Голливуде. Но вот беда — артист отлично знал и немецкий, и французский, но английский язык — «на дух не переносил». Небезызвестная подруга Вертинского Марлен Дитрих настоятельно рекомендовала ему «преодолеть отвращение любого нормального человека и взять себя в руки», но с такой задачей Вертинский справиться так и не смог. Поэтому и поступил, как настоящий русский, столкнувшийся с невероятно прекрасной возможностью — отказался.</div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  .bg-black
    background-color: #000
    position: relative
    margin-top: vw(-10px)
    z-index: 300
    &:after
      content: ''
      width: 100%
      height: 100%
      background-image: url(../assets/img/noise.gif)
      background-size: 10vw
      position: absolute
      top: 0
      left: 0
      opacity: 0.1
  .block-n
    position: relative
    z-index: 100
    padding-top: vw(34px)
    &__text
      width: vw(773px)
      margin: auto
      text-align: center
      margin-top: vw(39px)
      line-height: vw(20px)
      font-family: 'Tautz'
      font-size: vw(16px)
    &__row
      display: flex
      justify-content: center
    &__title
      font-size: vw(50px)
      font-weight: 100
      font-family: 'ZnikomitNo25'
      color: #fff
      span
        color: #AD1E1D
      &--1
        margin-bottom: vw(8px)
      &--2
        text-align: right
        letter-spacing: vw(3.47px)
      &--3
        letter-spacing: vw(3.57px)
        padding-left: 3px
        margin-bottom: vw(7px)
    &__letter
      padding-left: vw(28px)
      padding-top: vw(13px)
      margin-right: vw(26px)
      margin-left: vw(26px)
      @media screen and (max-width: 999px)
        margin-left: auto
        margin-right: auto
    &__head
      &--1
        margin-top: vw(21px)
      &--2
        margin-top: vw(79px)
</style>
